import { render } from "./SurveyWelcomeStep.vue?vue&type=template&id=563a3c50&scoped=true"
import script from "./SurveyWelcomeStep.vue?vue&type=script&lang=js"
export * from "./SurveyWelcomeStep.vue?vue&type=script&lang=js"

import "./SurveyWelcomeStep.vue?vue&type=style&index=0&id=563a3c50&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563a3c50"]])

export default __exports__